import {DataStatus} from 'platform/components';
import {Clickable, Icon} from 'platform/foundation';

import {isNil} from 'ramda';

import {useLazyGetAdvertisementServerLinkQuery} from '../../../store/priceReportApi';
import {GetAdvertisementServerLinkApiArg} from '../../../types/api/api';
import {handleApiError} from '../../../utils/handleApiError';

export interface AdServerLinkButtonProps {
  requestArg: GetAdvertisementServerLinkApiArg | null;
}

export function AdServerLinkButton(props: AdServerLinkButtonProps) {
  const [getLink, {isFetching}] = useLazyGetAdvertisementServerLinkQuery();

  const onClick = () => {
    if (isNil(props.requestArg)) {
      return;
    }
    getLink(props.requestArg)
      .unwrap()
      .then((response) => {
        if (isNil(response?.url)) {
          throw new Error("Server hasn't returned the URL!");
        }
        window.open(response.url, '_blank');
      })
      .catch(handleApiError);
  };

  return (
    <DataStatus spinnerSize="small" isLoading={isFetching}>
      <Clickable onClick={onClick}>
        <Icon value="action/open_in_new" size={4} color="palettes.neutral.800.100" />
      </Clickable>
    </DataStatus>
  );
}
